export function getTypePeopleText(type: any): string {
    switch(type) {
        case 'physical':
            return 'Pessoa Física';
        case 'legal':
            return 'Pessoa Jurídica';
        default:
            return '';
    }
}